import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, ListHeader, BorrowerRelif, RelifExportList } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ExportRelif = function ExportRelif(_ref) {
  var match = _ref.match;
  var BorrowerRelifTab = useCallback(function () {
    return ___EmotionJSX(BorrowerRelif, null);
  }, []);
  var RelifExportListTab = useCallback(function () {
    return ___EmotionJSX(RelifExportList, null);
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0420\u0435\u041B\u0418\u0424"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/borrower-relif",
    component: BorrowerRelifTab,
    label: "\u041B\u0438\u0446\u0430\u0442\u0430 \u043F\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/relif-exports",
    component: RelifExportListTab,
    label: "\u0421\u043F\u0438\u0441\u044A\u043A \u0435\u043A\u043F\u043E\u0440\u0442\u0438"
  })));
};

ExportRelif.propTypes = {
  match: PropTypes.object
};
export default ExportRelif;